import React from 'react'
import PropTypes from 'prop-types'

const DummyLine = ({ h='h-2', m='mb-2.5', w }) => (
  <div className={`${h} bg-gray-200 rounded-full dark:bg-gray-700 ${m} ${w}`}></div>
)

const DummyListLines = () => (
  <div className="flex items-center justify-between pt-4">
    <div>
      <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
      <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
    </div>
    <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
  </div>
)

export const TitleSkeleton = () => (
  <div className="flex flex-col justify-center">
    <DummyLine h="h-8" m="mb-8 mx-auto" w="md:w-96 w-40" />
  </div>
)

export const ImageSkeleton = () => (
  <div className="bg-white max-w-sm p-4 border border-gray-200 shadow animate-pulse md:p-6 dark:border-gray-700 mr-7 rounded-lg" role="status">
    <div className="flex items-center justify-center h-48 mb-4 bg-gray-300 rounded dark:bg-gray-700">
      <svg aria-hidden="true" className="w-10 h-10 text-gray-200 dark:text-gray-600" fill="currentColor" viewBox="0 0 16 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
        <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
      </svg>
    </div>
    <DummyLine h="h-2.5" m="mb-4" w="w-60" />
    <DummyLine />
    <DummyLine />
    <DummyLine m="0" />
    <span className="sr-only">Loading...</span>
  </div>
)

export const LandskapeImageSkeleton = () => (
  <div className="bg-white md:w-9/12 w-full p-4 space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center" role="status">
    <div className="flex items-center justify-center w-full h-64 bg-gray-300 rounded dark:bg-gray-700">
      <svg aria-hidden="true" className="w-10 h-10 text-gray-200 dark:text-gray-600" fill="currentColor" viewBox="0 0 20 18" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
      </svg>
    </div>
    <div className="w-full">
      <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
      <DummyLine />
      <DummyLine />
      <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[480px] mb-2.5"></div>
      <DummyLine />
      <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[480px] mb-2.5"></div>
    </div>
    <span className="sr-only">Loading...</span>
  </div>
)

export const ListSkeleton = () => (
  <div className="w-full bg-white p-4 space-y-4 border border-gray-200 divide-y divide-gray-200 rounded shadow animate-pulse dark:divide-gray-700 md:p-6 dark:border-gray-700" role="status">
    <DummyListLines />
    <DummyListLines />
    <DummyListLines />
    <DummyListLines />
    <DummyListLines />
    <span className="sr-only">Loading...</span>
  </div>
)

DummyLine.propTypes = {
  h: PropTypes.string,
  m: PropTypes.string,
  w: PropTypes.string,
}
